
import React from "react";

const QueryBox = ({ query, setQuery, errors, setErrors }) => {
  const handleInputChange = (e) => {
    setQuery(e.target.value);

    // Remove query error when the user starts typing
    if (errors.query) {
      setErrors((prevErrors) => ({ ...prevErrors, query: "" }));
    }
  };

  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold mb-2">
        Kindly mention your query *
      </h3>
      <textarea
        value={query}
        onChange={handleInputChange}
        className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
        rows="6"
      />
      {errors.query && (
        <p className="text-red-500 text-sm mt-1">{errors.query}</p>
      )}
    </div>
  );
};

export default QueryBox;